import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import {
  Collapse} from '@material-ui/core';
import { 
  Modal,
  Button,
  Icon,
  Label } from  'semantic-ui-react'
import r from 'reactotron-react-js'

const K2ErrorModal = (props) => {
  const {
    checkK2Error,
    show,
    setShow,
    showMore,
    setShowMore
  } = props
  return (
    <div style={{display:'flex'}}>
      {checkK2Error.isError&&
        <Button size='mini' color='red' icon labelPosition='left' onClick={()=>setShow(true)}>
          <Icon name='close' />
          View K2Error
        </Button>
      }
      <Modal open={checkK2Error.isError&&show} size='tiny'>
        <Modal.Header>Systems Message</Modal.Header>
        <Modal.Content>
          <div style={{display:'flex',flexDirection:'column'}}>
            <div>
              K2 error please contact Admin
            </div>
            <div style={{marginTop:'1rem'}}>
              <a onClick={()=>setShowMore(!showMore)}>Error message...</a>
              <Collapse in={showMore}>
                <div style={{marginLeft:'1rem',color:'red',whiteSpace: 'pre-wrap'}}>{checkK2Error.msg}</div>
              </Collapse> 
            </div>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button color='yellow' onClick={()=>setShow(!show)}>
            <Icon name='remove' /> Close
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  )
}

const mapStateToProps = (state) => ({
  checkK2Error: state.pr.checkK2Error
})
const mapDispatchToProps = {
  
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('show','setShow',true),
  withState('showMore','setShowMore',false),
  connect((state, props) => ({
    history: props.history
  })),
  lifecycle({
    componentDidMount() {
     
    },
    componentWillReceiveProps(nextProp) {
      
    }
  })
)

export default enhance(K2ErrorModal)
